import React, { useEffect, useState } from "react";
import { Banner } from '../../components';
import { ClientsRow } from '../../components';
import { HeroIndustries } from '../../components';
import { IndustriesSpriteJpg } from '../../components';
import { IndustriesIframeBlock } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScroll } from '../../components';
import { IndustriesCarouselMenu } from '../../components';
import { VideoScrollAlone } from '../../components';
import { Loader } from '../../components';
import { imagesArray } from '../../sprites/Interior';
import { BaseUrl } from "../../config";

const LandingInteriorContainer = (props) => {

  const imgHeroIndustries = require('../../assets/hero-interior.png');
  const imgposterVideoBis = require('../../assets/video/video-test-bis-poster.jpg');
  const imgposterVideo = require('../../assets/video/video-test-poster.jpg')
  
  const sprites = imagesArray;
  const arrayLoad = [
    imgHeroIndustries,
    imgposterVideoBis,
    imgposterVideo,
    ...sprites
  ]
  const boxesArray = [
    {
      title: "Highest Quality",
      text: "Our ultra-realistic real-time rendered 3D Digital Twins are compliant to the most stringent of industry standards and created through our patented pipeline methodologies."
    },
    {
      title: "Active Experience",
      text: "We bring the digital experience to the highest level, comparable to the real-world experience where users can fully engage with the environment, products, and assets."
    },
    {
      title: "Growth Acceleration",
      text: "Transform and boost your business and company towards a “digital culture” and enable yourself to experience the enhanced opportunities of the full digital ecosystem."
    }
  ];
  const [listClients, setListClients] = useState([]);

  useEffect(() => {
    document.title = "Invrsion for Interior Design"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=interior`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setListClients(res.data.company.clients);
    })
    
    
  }, []);
  return (
    <React.Fragment>
      <HeroIndustries 
        title="A new era for Interior Design starts here."
        bgColor="linear-gradient(105.88deg, #1A60D0, #B9D0E4 )"
        img={imgHeroIndustries}
      />
    
      <IndustriesSpriteJpg 
        idScroll="2-interior" 
        title="How our Full Reality solutions fulfill your needs" 
        black="#091749"
        boxesArray={boxesArray}
        imagesArray={sprites}
        iframeUrl="https://sketchfab.com/models/db4ae0b0dcfa445a929e8a35cd0da78a/embed?annotations_visible=0&amp;camera=0&amp;animation_autoplay=0&amp;autostart=0&amp;ui_controls=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_stop=0&amp;ui_watermark=0&amp;ui_watermark_link=0&amp;preload=1&amp;scrollwheel=0&amp;sound_enable=0&amp;ui_animations=0&amp;ui_annotations=0&amp;ui_ar=0&amp;ui_fadeout=0&amp;ui_fullscreen=0&amp;ui_help=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_settings=0&amp;ui_stop=0&amp;ui_theatre=0&amp;ui_vr=0&amp;ui_watermark=0&amp;pixel_budget=0"
      />
      <IndustriesIframeBlock 
        bgColor="#B9D0E4"
        url="51addebd3aff44c0bb0aeffdf810d2f5"
        title="3D e-commerce"
        black="#091749"
        route="3d-e-commerce"
        zoom="320"
        mobileSrc={require('../../assets/iframe-placeholder/Moroso_thumbnail.png')}

        text="Our solution to transform your online interior design goods into Full Reality 3D models for maximum engagement. Manipulate and see every detail of your products come to life, thanks to our house blend of advanced digitization techniques."
      />
      <VideoFullSection 
        bgColor="#D2E2F4"
        title="Virtual Showroom"
        black="#091749"
        route="/virtual-showroom"
        zIndex={2}
        text="Our solution to fully immerse potential buyers and investors in the spaces and projects you want to sell and rent. Giving them the keys to every listing you have on the market."
      >
        <VideoScroll 
          idScroll="video-01-interior" 
          video={require('../../assets/video/video-interior-1.mp4')} 
        />
      </VideoFullSection>
      
      <IndustriesCarouselMenu
        colorCTA="#1A60D0"
        black="#091749"
        slider={[1,3,2]}
      >
        <h3 className="big--title" style={{color: '#091749'}}>
          We want to help you design the future
        </h3>
      </IndustriesCarouselMenu>
      <VideoScrollAlone
        idScroll="video-interio-02"
        video={require('../../assets/video/video-interior-2.mp4')} 
      />
      {
        listClients.length > 0 &&
        <ClientsRow 
          black="#091749"
          title="Interior design brands that are already on board and trust in Invrsion's solutions"
          arrayClients={listClients}/>
        }
      <Banner bgColor="#E3EEFF" text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" black="#091749"/>
      <Loader arrayLoad={arrayLoad} />
        
    </React.Fragment>
  );
};

export default LandingInteriorContainer;
